var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamondWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-user-info",
    transform: "translate(-685.000000, -230.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platinum-Diamond-",
    transform: "translate(670.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    transform: "translate(15.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlatinumDiamond",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9422972,1.53695652 L14.2665644,3.6026087 L16.7793938,3.6026087 L14.6487211,1.53695652 L12.9422972,1.53695652 Z M11.754444,1.53695652 L7.48689634,1.53695652 L6.07059522,3.6026087 L13.0787111,3.6026087 L11.754444,1.53695652 Z M6.27441661,1.53695652 L4.15502687,1.53695652 L2.17440154,3.6026087 L4.85811549,3.6026087 L6.27441661,1.53695652 Z M11.3193874,9.5549903 L16.7036354,4.6026087 L14.1845213,4.6026087 L11.3193874,9.5549903 Z M7.89072417,9.71375409 L4.93373956,4.6026087 L2.31448876,4.6026087 L7.89072417,9.71375409 Z M6.08903372,4.6026087 L9.55913043,10.6006679 L13.0292272,4.6026087 L6.08903372,4.6026087 Z M9.63932399,12.4589784 L9.55913043,12.5975929 L9.53464173,12.5552642 L9.52276254,12.5661906 L0.299964073,4.11262638 L3.72845139,0.536956522 L15.0538876,0.536956522 L18.7281853,4.09912776 L9.63932399,12.4589784 Z",
    id: "icDiamondWhite"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondWhite);
export default __webpack_public_path__ + "static/media/icDiamondWhite.859c5d473737539ba79fd5c7739207a0.svg";
export { ForwardRef as ReactComponent };